<template lang="pug">
v-card.mb-3
  v-data-table(:items="items" :headers="headers" hide-actions)
    template(slot="items" slot-scope="{item}")
      tr
        td {{item.abteilung}}
        td.error--text.text-xs-right {{item.offen}}
        td.warning--text.text-xs-right {{item.inBearbeitung}}
        td.success--text.text-xs-right {{item.erledigt}}
        td.text-xs-right {{item.geschlossen}}

</template>

<style lang="stylus">
.table-slim.table-slim.table-slim.table-slim
  padding-left 0
  padding-right 4px

</style>

<script>
import gql from 'graphql-tag'
import { uniq, sumBy } from 'lodash'

export default {
  props: ['extra'],
  data() {
    return {
      headers: [
        { text: "Tickets", sortable: false },
        { text: "Offen", sortable: false, class: "table-slim text-xs-right" },
        { text: "In Bearbeitung", sortable: false, class: "table-slim text-xs-right" },
        { text: "Erledigt", sortable: false, class: "table-slim text-xs-right" },
        { text: "Geschlossen", sortable: false, class: "table-slim text-xs-right" },
      ]
    }
  },
  computed: {
    items() {
      return JSON.parse(this.extra && this.extra.content || null) || []
    }
  },
}
</script>
 